<template>
  <div class="user-timeline-wrapper">
    <div v-for="(item, index) in getGroupedByDate" :index="index">
      <div v-if="showStartNode(item[1])" class="node-date-wrapper">
        <div class="node-to-link">
          <div class="timeline-node" />
          <div class="timeline-link" />
        </div>
        <div class="date-styling">{{ getYear(item[0]) }}</div>
      </div>
      <!--Now we show all entities for a given date -->
      <div v-for="(entity, i) in filteredGroupedByDate(item[1])" :key="i">
        <div v-if="getCardTitle(entity)">
          <entity-card
            @click="$emit('onEntityCardClick', entity)"
            :cardTitle="getCardTitle(entity)"
            :date="formatDate(entity.eventDate)"
            style="margin: 0 !important"
          />
          <div v-if="showLink(i, filteredGroupedByDate(item[1]))" class="card-link" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Helpers from '../utils/helpers'
import { EntityCard } from '../ciitizen-component-library'
import get from 'lodash/get'

export default {
  name: 'UserTimeline',
  components: {
    EntityCard
  },
  props: {
    groupedByDate: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    getGroupedByDate() {
      return this.groupedByDate
    }
  },
  methods: {
    formatDate(date) {
      return Helpers.ciiFormatDate(date)
    },
    getYear(year) {
      if (year.length === 4) {
        return new Date().getFullYear() == year ? 'NOW' : year
      }
    },
    getCardTitle(entity) {
      return get(entity, 'data.codes[0].name', '')
    },
    showLink(index, total) {
      let newIndex = index + 1
      return newIndex !== total.length
    },
    showStartNode(list) {
      return list.some(l => l.data.codes)
    },
    filteredGroupedByDate(groupedList) {
      let filtered = groupedList.filter(l => l.data.codes && l.data.codes.length)
      return filtered
    }
  }
}
</script>

<style>
.node-to-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 15px;
  margin-left: 8px;
}
.timeline-node {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #9AA0A6;
}
.timeline-link {
  width: 1px;
  height: 30px;
  background: #9AA0A6;
}
.card-link {
  width: 1px;
  height: 20px;
  background: #9AA0A6;
  margin-left: 15px;
}
.node-date-wrapper {
  display: flex;
  align-items: baseline;
  margin-top: 20px;
}
.date-styling {
  font-size: 13px;
  color: #868585;
  margin-left: 8px;
}
</style>
